import { render, staticRenderFns } from "./FaqSections.vue?vue&type=template&id=ec4e5860&scoped=true&"
import script from "./FaqSections.vue?vue&type=script&lang=js&"
export * from "./FaqSections.vue?vue&type=script&lang=js&"
import style0 from "./FaqSections.vue?vue&type=style&index=0&id=ec4e5860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4e5860",
  null
  
)

export default component.exports